import * as i18n from "../i18n.ts";
import ApiServer from "../ApiServer.js";


ApiServer["custom.forgotpasswordonepage"] = async function(form){
  var 
    identifier = form.identifier.value;
  try{
    await ApiServer.log2forgotpassword2(identifier)
  }catch(e){
    //console.log(e)
  }
  var confirmContainerText = $("#confirm-container").show().find('span');
  if(identifier.indexOf('@')===-1){
    confirmContainerText.html(i18n.get('fw3.changepassword.info_password_reset_kidaccount_email_sent'))
  }else{
    confirmContainerText.html(i18n.get('fw3.changepassword.info_password_reset_email_sent'))
  }

}
